<h4 mat-dialog-title class="primary-color text-center">{{title}}</h4>
<mat-dialog-content class=" primary-color">
  <pre>{{content | json }}</pre>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button class="m-auto" color="accent" (click)="close()">Ok</button>
</mat-dialog-actions>
